import * as React from 'react';
import './index.scss';

export const Header = () => (
  <div className="Header">
    <h1 className="Header__title">Trova il tuo collegio elettorale</h1>
  </div>
);
